export const messagesTabKeys = {
  conversations: 'conversations',
  contacts: 'contacts',
};
